import { track } from './mixpanel';
import * as EVENTS from './events';

export const identifyUser = ({ source }) => {
  track(EVENTS.USER_LOGIN, { source });
};
